import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import PricingSection from "@/components/landing/PricingSection";
import CTASection from "@/components/landing/CTASection";
import Footer from "@/components/landing/Footer";
import FAQ from "@/components/landing/FAQ";
import SEO from "@/components/SEO";
import { organizationLd, websiteLd } from "@/lib/structured-data";

const Index = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      navigate("/dashboard", { replace: true });
    }
  }, [user, loading, navigate]);

  return (
    <div className="min-h-[100dvh]">
      <SEO
        title="VIZ Sandbox A — Classic Landing Concept"
        description="Internal sandbox preview of the classic VIZ landing concept — hero, features, how it works, pricing, and FAQ. Used for design comparison."
        path="/sandbox/landing-page-a"
        noIndex
        jsonLd={[organizationLd(), websiteLd()]}
      />
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <HowItWorksSection />
      <PricingSection />
      <FAQ />
      <CTASection />
      <Footer />
    </div>
  );
};

export default Index;
